/**
 * ============================================================
 * CRIATIVO SOL CORE™
 * M003 — Motion Utilities™
 * Version: 1.0.0
 * ============================================================
 *
 * Purpose:
 * Declarative helpers on top of M002 Motion Engine™.
 */

(() => {
  'use strict';

  window.CS = window.CS || {};
  window.CS.motion = window.CS.motion || {};

  const version = '1.0.0';

  function hasEngine() {
    return !!(window.CS.motion && window.CS.motion.engine);
  }

  function normaliseRevealClass(el) {
    if (el.dataset.csReveal) return;

    const map = [
      ['cs-reveal-fade', 'fade'],
      ['cs-reveal-up', 'fadeUp'],
      ['cs-reveal-left', 'fadeLeft'],
      ['cs-reveal-right', 'fadeRight'],
      ['cs-reveal-scale', 'scale'],
      ['cs-reveal-blur', 'blur'],
      ['cs-reveal-mask', 'mask'],
      ['cs-reveal-word', 'word']
    ];

    const match = map.find(([className]) => el.classList.contains(className));
    if (match) el.dataset.csReveal = match[1];
  }

  function hydrateDelays(root = document) {
    const groups = root.querySelectorAll('[data-cs-auto-stagger]');

    groups.forEach((group) => {
      const token = group.dataset.csAutoStagger || 'normal';
      const selector = group.dataset.csStaggerSelector || '[data-cs-reveal], .cs-reveal-up, .cs-reveal-fade, .cs-reveal-left, .cs-reveal-right, .cs-reveal-scale, .cs-reveal-blur, .cs-reveal-mask, .cs-reveal-word';
      const items = group.querySelectorAll(selector);

      items.forEach((el, index) => {
        normaliseRevealClass(el);
        if (!el.dataset.csDelay) el.dataset.csDelay = String(index);
        if (!el.dataset.csStaggerToken) el.dataset.csStaggerToken = token;
      });
    });
  }

  function hydrateRevealClasses(root = document) {
    root.querySelectorAll(
      '.cs-reveal-fade,.cs-reveal-up,.cs-reveal-left,.cs-reveal-right,.cs-reveal-scale,.cs-reveal-blur,.cs-reveal-mask,.cs-reveal-word'
    ).forEach(normaliseRevealClass);
  }

  function hydrate(root = document) {
    hydrateRevealClasses(root);
    hydrateDelays(root);

    if (hasEngine()) {
      window.CS.motion.engine.refresh(root);
    }
  }

  function revealSequence(elements, options = {}) {
    if (!hasEngine()) return;

    const delayStep = Number.isFinite(Number(options.delayStep))
      ? Number(options.delayStep)
      : 90;

    Array.from(elements).forEach((el, index) => {
      setTimeout(() => {
        window.CS.motion.engine.reveal(el);
      }, index * delayStep);
    });
  }

  window.CS.motion.utilities = Object.freeze({
    version,
    hydrate,
    revealSequence
  });

  function boot() {
    hydrate(document);
    document.documentElement.dataset.csMotionUtilities = version;

    window.dispatchEvent(new CustomEvent('cs:motion-utilities-ready', {
      detail: { version }
    }));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (event) => hydrate(event.target));
  document.addEventListener('shopify:block:select', (event) => {
    hydrate(event.target.closest('.shopify-section') || document);
  });
})();
